import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { TaskTemplateType } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import TaskDirTableBody from './TaskDirTableBody';

interface TaskDirTableProps {
    templates: TaskTemplateType[];
    showSpinner: boolean;
    /** Без колонки виконавця: вибір шаблону в панелі створення задачі. */
    hideExecutor?: boolean;
    onSelect?: (template: TaskTemplateType) => void;
    onEdit?: (template: TaskTemplateType) => void;
    onDelete?: (template: TaskTemplateType) => void;
}

const TaskDirTable = ({
    templates,
    showSpinner,
    hideExecutor = false,
    onSelect,
    onEdit,
    onDelete,
}: TaskDirTableProps) => {
    const { t } = useTranslation(['Tasks']);
    const withActions = Boolean(onEdit || onDelete);
    const colSpan = 3 + (hideExecutor ? 0 : 1) + (withActions ? 1 : 0);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur show={showSpinner} />
            <div className="crm-table-wrap">
                <Table
                    className={`TaskDirTable table-hover mb-0${hideExecutor ? ' TaskDirTable--compact' : ''}`}
                >
                    <thead>
                        <tr className="bg-light">
                            <td className="head-name">{t('directory.colName')}</td>
                            <td className="head-category">{t('directory.colCategory')}</td>
                            <td className="head-type">{t('directory.colType')}</td>
                            {hideExecutor ? null : (
                                <td className="head-username">{t('directory.colExecutor')}</td>
                            )}
                            {withActions ? <td className="head-action" /> : null}
                        </tr>
                    </thead>
                    <TaskDirTableBody
                        templates={templates}
                        colSpan={colSpan}
                        hideExecutor={hideExecutor}
                        onSelect={onSelect}
                        onEdit={onEdit}
                        onDelete={onDelete}
                    />
                </Table>
            </div>
        </div>
    );
};

export default TaskDirTable;
